<div class="stage">
  <canvas #bgCanvas id="bgCanvas" class="layer bg" aria-hidden="true"></canvas>

  <div class="dim-layer" aria-hidden="true"></div>

  <canvas #gameCanvas id="gameCanvas" class="layer game"></canvas>

  <div id="ui">
    <div class="topbar">
      <div>Score: <span>{{ score }}</span></div>
      <div>Best: <span>{{ best }}</span></div>
      <div>Time: <span>{{ elapsedLabel }}</span></div>
      @if (isDev) {
        <div>FPS: <span>{{ fps }}</span></div>
      }
      @if (!isMobile) {
      <div style="margin-left:auto; display:flex; gap:8px;">
        <div class="btn" title="P oder Esc">{{ state === 'PAUSE' ? '▶️ Resume' : '⏸ Pause' }}</div>
        <div class="btn" title="M">{{ muted ? '🔇 Mute' : '🔊 Sound' }}</div>
      </div>
      }
    </div>

    <div id="layerCenter" class="center" [innerHTML]="centerHtml"></div>

    <div style="display:flex; justify-content:center; padding:10px;">
      @if (isMobile) {
        <div class="hint">Tap to rise</div>
      } @else {
        <div class="hint">Tap/Click or <b>SPACE</b> to rise • <b>P</b> Pause • <b>R</b> Restart</div>
      }
    </div>
  </div>

  @if (rotateNotice) {
    <div class="rotate-overlay" aria-live="polite">
      <div class="rotate-box">
        <div style="font-size:28px; line-height:1.2;">Please rotate device</div>
        <div style="opacity:.85; font-size:14px; margin-top:6px;">Landscape mode required</div>
        <div class="rotate-icon">🔄</div>
      </div>
    </div>
  }
</div>
